import { Alert } from '@mui/material';
import { useInvestmentsQuery } from 'apis/investment/api';
import { useKycStatusesQuery } from 'apis/user/api';
import { KycStatus } from 'apis/user/types';
import {
  useActiveExchange,
  useCurrentUser,
  useIsAuthenticated,
} from 'apis/user/use';
import AnchorLink from 'components/AnchorLink';
import React from 'react';
import { ROUTE_KYC } from 'routes';
import { isFeatureOn } from 'whitelabel';
import { Features } from 'whitelabel/type';

const KycBanner = () => {
  const isAuthenticated = useIsAuthenticated();
  const { exchanges } = useCurrentUser();
  const exchange = useActiveExchange();
  const skip =
    !isAuthenticated ||
    !exchange?.internalId ||
    !isFeatureOn(Features.Kyc) ||
    !exchange?.activated;

  const { isLoading: investmentsLoading, data: investments } =
    useInvestmentsQuery(exchange?.internalId, {
      skip,
    });
  const { data: statusesRes } = useKycStatusesQuery(undefined, {
    skip,
  });
  const noKyc = statusesRes?.statuses.some(
    (s) =>
      s.category === 'KYC' &&
      s.level === 1 &&
      [KycStatus.NOT_STARTED, KycStatus.INIT].includes(s.status),
  );

  if (
    isFeatureOn(Features.Kyc) &&
    !investmentsLoading &&
    exchanges?.length === 1 &&
    (!exchange.activated || noKyc)
  ) {
    return (
      <Alert severity='warning' id='kyc-banner'>
        {investments?.length
          ? 'Urgent Reminder: KYC Deadline Approaching! '
          : 'Please pass KYC to access all services and start investing. '}
        <AnchorLink to={ROUTE_KYC}>{'Pass your KYC'}</AnchorLink>
      </Alert>
    );
  }

  return null;
};

export default KycBanner;
